import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { LOGOUT, CHECK_PENDING_POSTS } from '../core/handlers.actions';
import { AppBar, Button, Typography, IconButton, Toolbar, MenuList, MenuItem, Drawer, ListItemText, ListItemIcon, Icon, Badge, Tooltip, Divider } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { withStyles } from '@material-ui/core/styles';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import { routes } from '../core/router/';
import { NavLink, withRouter } from 'react-router-dom';
import clsx from 'clsx';
import NotificationsIcon from '@material-ui/icons/Notifications';
import HomeIcon from '@material-ui/icons/Home';
import CssBaseline from '@material-ui/core/CssBaseline';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';


const drawerWidth = 240;
const styles = (theme: any) => ({
    root: { flexGrow: 1, display: 'flex' },
    title: { flexGrow: 1 },
    name: { textDecoration: 'none', color: 'white' },
    drawer: { [theme.breakpoints.up('sm')]: { width: drawerWidth, flexShrink: 0 } },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    menuButton: { marginRight: theme.spacing(2) },
    // toolbar: theme.mixins.toolbar,
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        marginTop: 65
    },
    drawerPaper: { width: drawerWidth },
    content: { flexGrow: 1, padding: theme.spacing(3) },
    closeMenuButton: { marginRight: 'auto', marginLeft: 0 },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    badge: {
        marginRight: 45
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        'overflow-x': 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    iconColor: {
        color: 'rgba(73,14,111, .7)'
    }
});


interface Props {
    location?: any;
    user?: any;
    logOut: () => void;
    classes: any;
    checkPending: () => void;
    pendingPosts?: any;
    match: any,
    history: any
}
interface State {
    isOpen: boolean;
}

class Nav extends Component<Props, State> {
    state: State = {
        isOpen: false
    }

    constructor(props: Props) {
        super(props);
        this.toggleDrawer = this.toggleDrawer.bind(this);
        this.activeRoute = this.activeRoute.bind(this);
    }

    public componentDidMount() {
        const { checkPending } = this.props;
        checkPending();
    }

    public toggleDrawer() {
        this.setState({ ...this.state, isOpen: !this.state.isOpen });
    }

    public activeRoute(path: string) {
        const { location } = this.props;
        return location.pathname === path;
    }

    public render() {
        const { logOut, classes, pendingPosts, user } = this.props;
        const { isOpen } = this.state;
        
        return (
            <div>
                <div className={classes.root}>
                    <CssBaseline />
                    <AppBar position="fixed" className={clsx(classes.appBar, isOpen && classes.appBarShift)}>                        
                        <Toolbar>                            
                            <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={this.toggleDrawer}>
                                <MenuIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.title}>
                                PanCAN Core Engine 
                            </Typography>
                            <Typography variant="h6" className={classes.title}>
                                Welcome, {user.name}
                            </Typography>
                            <NavLink to="/">
                                <Tooltip title="Dashboard home" >
                                    <IconButton style={{ color: '#fff' }}>
                                        <HomeIcon />
                                    </IconButton>
                                </Tooltip>
                            </NavLink>
                            {pendingPosts && pendingPosts.length > 0 ?
                                <NavLink to="/pending-posts">
                                    <Tooltip title="Pending review posts" >
                                        <IconButton color="secondary">
                                            <Badge badgeContent={pendingPosts.length} className={classes.badge} color="secondary">
                                                <NotificationsIcon />
                                            </Badge>
                                        </IconButton>
                                    </Tooltip>
                                </NavLink>
                                : null}
                            <Button onClick={logOut} variant="contained" color="secondary" startIcon={<AccountBoxIcon />}> Log out </Button>
                        </Toolbar>
                    </AppBar>
                    <Drawer variant="permanent" className={clsx(classes.drawer, { [classes.drawerOpen]: isOpen, [classes.drawerClose]: !isOpen })} classes={{ paper: clsx(classes.drawer, { [classes.drawerOpen]: isOpen, [classes.drawerClose]: !isOpen }) }} open={isOpen} onClose={this.toggleDrawer}>
                        {isOpen ?
                            <div >
                                <IconButton onClick={this.toggleDrawer}>
                                    <ChevronLeftIcon />
                                </IconButton>
                            </div>
                            : null}
                        <div
                            className={!isOpen ? classes.toolbar : ''}
                            role="presentation"
                            onClick={this.toggleDrawer}
                            onKeyDown={this.toggleDrawer}>
                            
                            <MenuList>
                                {routes.map((prop, key) => {
                                    return (
                                        (prop.isProtected && prop.sidebar && !prop.admin) ?
                                            <NavLink to={prop.path} style={{ textDecoration: 'none' }} key={key}>
                                                <MenuItem selected={this.activeRoute(prop.path)}>
                                                    <ListItemIcon><Icon className={'fa ' + prop.icon + ' ' + classes.iconColor} /></ListItemIcon>
                                                    <ListItemText primary={prop.sidebarName} className='nav-drawer-text' />
                                                </MenuItem>
                                            </NavLink>
                                            : null
                                    );
                                })}
                                 <Divider />
                                {/** Run it to check for admin options */}
                                {routes.map((prop, key) => {
                                    return (
                                        (prop.isProtected && prop.sidebar && prop.admin && user.role === 'admin') ?
                                            <NavLink to={prop.path} style={{ textDecoration: 'none' }} key={key}>
                                                <MenuItem selected={this.activeRoute(prop.path)}>
                                                    <ListItemIcon><Icon className={'fa ' + prop.icon + ' ' + classes.iconColor} /></ListItemIcon>
                                                    <ListItemText primary={prop.sidebarName} className='nav-drawer-text'/>
                                                </MenuItem>
                                            </NavLink>
                                            : null
                                    );
                                })}                               
                            </MenuList>                           

                        </div>
                    </Drawer>
                </div>
            </div>
        );
    }
}

const mapToProps = (app: any) => ({ user: app.rootReducer.user, pendingPosts: app.rootReducer.pendingPosts });
const mapDipatch = (dispatch: Dispatch) => ({
    logOut: () => dispatch({ type: LOGOUT }),
    checkPending: () => dispatch({ type: CHECK_PENDING_POSTS })
});
export default withRouter(connect(mapToProps, mapDipatch)(withStyles(styles)(Nav)));

